<template>
    <div>
        <compra-direta-ferramenta-de-busca  v-model="filtrosBuscaAvancada"
                                            :situacoesPossiveis="situacoesCompraDiretaPermitidas"
                                            :placeholderPesquisa="placeholderPesquisa"
                                            :filtros="filtrosInterno"
                                            @eventoBuscaSimples="tratarEventoBuscaSimples"
                                            @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                            @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                            @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
        </compra-direta-ferramenta-de-busca>

        <compra-direta-em-homologacao-tabela :itens="itens"
                                             @acessar="tratarEventoAcessar" @acessarPncp="acessarPncp"/>
    </div>
</template>

<script>
import _ from 'lodash'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import {actionTypes, mutationTypes, situacoesCompraDireta} from '@/core/constants'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'
import CompraDiretaEmHomologacaoTabela from './CompraDiretaEmHomologacaoTabela'

export default {
    name: 'CompraDiretaEmHomologacao',
    components: {
        CompraDiretaFerramentaDeBusca,
        CompraDiretaEmHomologacaoTabela
    },
    data() {
        return {
            filtrosInterno: {},
            filtrosBuscaAvancada: {},
            itens: [],
            paginas: 0,
            totalItens: 0,
            idItemParaDeletar: null,
            ehBuscaAvancada: false
        }
    },
    computed: {
        placeholderPesquisa() {
            const texto = this.$t('main.comprador_todas_compras_diretas_orgao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        },
        situacoesCompraDiretaPermitidas() {
            return situacoesCompraDireta
        }
    },
    mounted() {
        this.filtrosInterno = this.getFiltrosComprador()
        this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancada()

        this.buscarComprasDiretasEmHomologacao()
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_TODAS_COMPRAS_DIRETAS, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_TODAS_COMPRAS_DIRETAS)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancada()
        },
        async buscarComprasDiretasEmHomologacao() {
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.AUTORIDADE_SUPERIOR.BUSCAR_COMPRAS_DIRETAS_HOMOLOGACAO)
            this.itens = resultado.itemList
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.conteudo = valor
                this.filtrosInterno.objeto.value = valor
                this.buscar()
            }
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancada()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancada()
            this.buscar()
        },
        tratarEventoAcessar(item) {
            const id = item.id
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'CompraDiretaEmHomologacao')

            const permissoesRequeridas = ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior']

            if (azAuth(this.$store.state.loki.user.authorities, permissoesRequeridas)) {
                this.$router.push({name: 'Resultado', params: {id}, query: {'processamento':'homologacao'}})
            }
        },
        async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp}) {
            await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp})
        },
        getFiltrosComprador() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaTodasComprasDiretas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        getFiltrosBuscaAvancada() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.filtros)
        },
        resetFiltroBuscaAvancada(){
            this.ehBuscaAvancada = false
            this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.reset()
            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_TODAS_COMPRAS_DIRETAS, paginacaoInicial)
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_COMPRADOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        }
    }
}
</script>
